import React from "react";
import { connect } from "react-redux";
import { Filter, Icon, Loader, TableCard, utils } from "@mc/mc-legacy";
import CustomPageLayout from "./CustomPageLayout";
import AdminMenu from "../administrace/lists/components/AdminMenu";
import * as actions from "../actions/OverviewActions";
import PrehledTable from "../components/PrehledTable";
import PrehledFilter from "../components/PrehledFilter";
import * as fieldActions from "../actions/fieldActions";
import { toastr } from "../utils/mc-toastr";
import saveOrOpenBlob from "../utils/saveOrOpenBlob";
import { Button } from "reactstrap";
import CustomPrehledApi from "../api/CustomPrehledApi";
import "./SestavyPage.scss";
/**
 * Stránka pro sestavy a přehledy.
 */

class SestavyPage extends React.Component {
  state = {
    exportingXlsx: false, // Zda probíhá export do XLSX
  };

  componentDidMount() {
    this.fetchData(this.props, true);
    this.props.dispatch(fieldActions.findAllPersons());
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.fetchData(nextProps);
  }

  fetchData = (props, force) => {
    props.dispatch(actions.fetchIfNeeded(false));
  };

  exportXlsx() {
    const { overview } = this.props;
    this.setState({
      exportingXlsx: true,
    });
    let filter = overview.filter;
    filter = Filter.purifyValues(filter);
    CustomPrehledApi.exportOverview(filter)
      .then((blob) => {
        this.setState({
          exportingXlsx: false,
        });
        saveOrOpenBlob(blob, {
          filename: `${"qsign_admin_prehled"}_${new Date().getTime()}.xlsx`,
        });
      })
      .catch((error) => {
        this.setState({
          exportingXlsx: false,
        });
        toastr.error("Chyba exportu do XLSX: " + error.message);
      });
  }

  renderHeader = () => {
    const { overview } = this.props;
    const { exportingXlsx } = this.state;
    return (
      <div className="filter-header">
        <Button
          type="button"
          title={"Export do Excelu"}
          color="default"
          className={"xlsx-export"}
          disabled={exportingXlsx}
          onClick={() => {
            this.exportXlsx();
          }}
        >
          {exportingXlsx ? (
            <Icon icon="circle-o-notch" animation={Icon.animation.spin} fixedWidth />
          ) : (
            <Icon icon="file" />
          )}
          <br />
          Export
        </Button>
        <PrehledFilter />
        {overview.fetched && (
          <div className="mt-5 mb-2">
            Počet nalezených položek: <span className="count">{overview.rows.length}</span>
          </div>
        )}
      </div>
    );
  };
  renderTableCard = () => {
    const { overview, personList } = this.props;

    if (overview.isFetching || personList.isFetching) {
      return <Loader />;
    }

    if (overview.fetched && personList.fetched) {
      return <PrehledTable rows={overview.rows} personList={personList.rows} />;
    } else {
      return <i>Přehled není dostupný</i>;
    }
  };
  renderContent = () => {
    return (
      <div className={"sestavy-page"}>
        <TableCard className="inverse" header={this.renderHeader()}>
          {this.renderTableCard()}
        </TableCard>
      </div>
    );
  };

  render() {
    return (
      <CustomPageLayout header headerButton={false} searchField={false} title="Sestavy a přehledy" menu={<AdminMenu />}>
        {this.renderContent()}
      </CustomPageLayout>
    );
  }
}

function mapStateToProps(state) {
  return {
    overview: utils.storeFromArea(state, actions.OVERVIEW),
    personList: utils.storeFromArea(state, fieldActions.QSIGN_PERSON_LIST),
  };
}

export default connect(mapStateToProps)(SestavyPage);
